import React, {useState} from 'react';
import {Grid, Message, Form, Button, Header, Modal, Icon} from "semantic-ui-react";
import ClassLevelModal from "../../../editComponents/ClassLevelModal";

function AddDialogFlashCardComponent(
    {
        handleChange,
        forms,
        createForms,
        handleClearData,
        editAssignment,
        assignment
    }
) {

    const [open, setOpen] = useState(false);

    return (
        <>
            <Modal
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                open={open}
                trigger={<Button color='black' style={{marginTop: 5, marginLeft: 5}}>
                    <Icon name='warning'/>
                    Clear Data
                </Button>}
            >
                <Modal.Header>Clear Data</Modal.Header>
                <Modal.Content image>
                    <Modal.Description>
                        <p>
                            You are attempting to clear the data on this page for any of these reasons:<br/><br/>
                            1. You are finished uploading the assignment and want to add a new one.<br/>
                            2. You made a mistake and would like to restart.<br/>
                            3. You have encountered an error on submitting the assignment and would like to start
                            over.<br/>
                            4. If you are editing an assignment and would like to start from scratch.<br/><br/>
                            <b>Are you sure you want to clear the data on this page?</b>

                        </p>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button color='red' onClick={() => {
                        setOpen(false);
                        handleClearData();
                    }}>
                        Yes
                    </Button>
                    <Button
                        content="No"
                        onClick={() => setOpen(false)}
                    />
                </Modal.Actions>
            </Modal>
            <Grid centered={true}>
                {
                    editAssignment ?
                        <Grid.Row>
                            <Header as='h1'>
                                You are editing {assignment} in Dialog Flash Cards
                            </Header>
                        </Grid.Row>
                        :
                        <Grid.Row>
                            <Header as='h1' style={{color: 'black'}}>
                                Add Dialog Flash Cards
                            </Header>
                        </Grid.Row>
                }

                <Message color='blue'>
                    <Header as='h2' textAlign='left' color='black'>
                        <h2 style={{color: 'black'}}>
                            Directions:
                        </h2>
                    </Header>
                    <p style={{textAlign: 'left', color: "black"}}>
                        <b>Note: In order for the data to be saved properly, please specify the correct number of flash cards before filling in the fields. </b>
                        <br/><br/>
                        Below, choose the number of questions in your assignment and click "Build Assignment".
                        <br/><br/>
                        Speaker A will represent one side of the flash card and is labeled in blue.
                        <br/>
                        Fill in the Samoan Phrase and the English Translation for speaker A where indicated.
                        <br/><br/>
                        Speaker B will be the response to speaker A.
                        <br/>
                        Speaker B will represent the other side of the flash card and is labeled in green.
                        <br/>
                        Fill in the Samoan Phrase and the English Translation for speaker B where indicated.
                        <br/><br/>
                        If you would like to add multiple questions/responses,
                        <br/>
                        Click on the + button to create new fields for speaker A or speaker B.
                        <br/>
                        If you would like to delete the added fields, click on the - button for speaker A or speaker B.
                        <br/>
                        Then fill in the fields were necessary.
                        <br/><br/>
                        You may also upload audio files for speaker A and speaker B if available.
                    </p>
                </Message>

                <Grid.Row>
                    {
                        editAssignment ?
                            null
                            :
                            <Form>
                                <Form.Field>
                                    <label>Please Enter the number of flash cards in the assignment</label>
                                    <input onChange={handleChange} type='number' style={{width: 100, marginLeft: 50}}/>
                                    <Button onClick={createForms} style={{marginLeft: 10}} color='blue'>Build
                                        Assignment</Button>
                                </Form.Field>
                            </Form>
                    }


                </Grid.Row>
                {/*{forms}*/}


            </Grid>
        </>
    )
}

export default AddDialogFlashCardComponent
